import { Badge } from "@/components/ui/badge"

export const statusConfig = {
  pending: { label: "Pending", className: "bg-amber-50 text-amber-700 border-amber-200" },
  reviewed: { label: "Reviewed", className: "bg-blue-50 text-blue-700 border-blue-200" },
  contacted: { label: "Contacted", className: "bg-purple-50 text-purple-700 border-purple-200" },
  completed: { label: "Completed", className: "bg-green-50 text-green-700 border-green-200" },
  rejected: { label: "Rejected", className: "bg-red-50 text-red-700 border-red-200" },
}

export function StatusBadge({ status }) {
  const config = statusConfig[status] || statusConfig.pending
  return (
    <Badge variant="outline" className={config.className}>
      {config.label}
    </Badge>
  )
}
